(ns admin.components.composite.resource-viewer
  (:require
   [re-frame.core :as re-frame]

   [kyber.styles.core :refer [gs styles->classes]]
   [kyber.components.base.icons :as icon]
   [kyber.components.base.text :as text]
   [kyber.components.base.button :as button]
   [kyber.components.base.link :as link]
   [kyber.components.composite.image-viewer :as image-viewer]
   [kyber.components.composite.resource :as resource]
   [kyber.components.composite.media-player :as media-player]
   [kyber.components.composite.pdf-viewer :as pdf-viewer]))

(def classes
  (styles->classes
   {:resource-overlay-container
    {:position :fixed
     :display :flex
     :justify-content :center
     :align-items :center
     :top "-100%"
     :left 0
     :width "100%"
     :height "100%"
     :background (gs [:overlay :gray])
     :z-index 100
     :transition "0.4s ease-in-out top"

     "&.active-resource"
     {:top 0}}

    :resource-viewer-container
    {:width "80%"
     :height "100%"
     :padding [(gs [:spacing :p0])
               (gs [:spacing :p40])]
     :background-color (gs [:colors :true-white])}

    :media-container
    {:height "100%"
     :width "70%"
     :display :flex
     :justify-content :center
     :align-items :center
     :overflow :auto
     :padding-right (gs [:spacing :p40])}

    :resource-details
    {:display :flex
     :flex-direction :column
     :justify-content :space-between
     :width "30%"
     :height "100%"
     :padding-top (gs [:spacing :p40])
     :padding-bottom  (gs [:spacing :p40])
     :padding-left (gs [:spacing :p40])
     :border-left (str "1px solid " (gs [:colors :true-black]))

     "& > *"
     {:margin-bottom (gs [:spacing :p24])
      "&:last-child"
      {:margin-bottom (gs [:spacing :p0])}}}

    :title-wrapper
    {:padding-bottom (gs [:spacing :p16])
     :border-bottom (str "1px solid " (gs [:colors :gray-scale-300]))}

    :description-wrapper
    {:overflow-y :auto}

    :title-and-description-wrapper
    {:display :flex
     :flex-direction :column
     :overflow :auto}

    :button-container
    {:display :flex
     :justify-content :space-between}}))

(defn missing-resource
  []
  [:div {:style {:width "100%"
                 :height "100%"
                 :display :flex
                 :justify-content :center
                 :align-items :center
                 :text-align :center}}
   [:div
    [icon/icon-lg :download]
    [text/title-40 :p "Preview Unavailable"]
    [text/body-30 :p "Learners will be given the option to download resource"]]])

(defn render
  []
  (let [resource-library (re-frame/subscribe [:resource-library])]
    (fn []
      (let [{:keys [active-resource]}
            @resource-library

            {:resource/keys [file-type name url description]}
            active-resource

            file-type-keyword
            (keyword file-type)

            viewer-component
            (when (some? active-resource)
              (case file-type-keyword
                :image image-viewer/render
                :pdf pdf-viewer/render
                :video media-player/render
                :audio media-player/render
                missing-resource))]

        [:div {:class [(:resource-overlay-container classes)
                       (when (some? active-resource)
                         "active-resource")]}
         (when (some? active-resource)
           [:div {:class (:resource-viewer-container classes)}
            [:div {:style {:display :flex
                           :height "100%"}}
             [:div {:class (:media-container classes)}
              (cond-> [viewer-component]
                (or (= :video file-type-keyword)
                    (= :audio file-type-keyword))
                (conj {:plo active-resource
                       :player-key :resource-viewer
                       :show-controls true})

                (or (= :pdf file-type-keyword)
                    (= :image file-type-keyword))
                (conj active-resource)

                (= :pdf file-type-keyword)
                (conj {:attach-events false}))]
             [:div {:class (:resource-details classes)}
              [:div {:class (:title-and-description-wrapper classes)}
               [text/title-30 :p {:class (:title-wrapper classes)} name]
               [:div {:class (:description-wrapper classes)}
                [text/body-30 :p {:style {:word-break :break-all}}
                 (if (some? description)
                   description
                   "No description provided")]]]
              [:div {:class (:button-container classes)}
               [button/primary-button
                {:on-click #(re-frame/dispatch
                             [:resource-library/close-resource-viewer])}
                "Close"]
               [link/secondary-anchor-button
                {:href (str (resource/get-source url) "&type=source")
                 :target "_blank"}
                "Download Resource"]]]]])]))))
